import TemplateContents from './TemplateContents';
import { gsap } from 'gsap';

export default class extends TemplateContents {
  constructor(param) {
    super(param);
  }

  init() {
    super.init();
    this.initBigCircleAnimation();
  }

  reset() {
    super.reset();
    this.setVars();
  }

  destruct() {
    super.destruct();
    if (this.bigCircleTween) {
      this.bigCircleTween.kill();
    }
  }

  setVars() {
    super.setVars();
    this.circleColors = ['#E65080', '#EF8DA5', '#E2C3A6'];
    this.bigCircleTween = null;
    this.parallaxSpeed = 0.17;
  }

  setDom() {
    super.setDom();

    this.section3Dom = document.querySelector('main.top .section3');
    this.col1Text = document.querySelector('main.top .section3 .col.col1 .text');
    this.col1BiggerItems = this.col1Text ? this.col1Text.querySelectorAll('.bigger .item') : [];

    // .bigger の前後の .item を分割
    const col1Bigger = this.col1Text ? this.col1Text.querySelector('.bigger') : null;
    const col1AllItems = this.col1Text ? Array.from(this.col1Text.querySelectorAll('.item')) : [];
    const col1BiggerArr = Array.from(this.col1BiggerItems);
    this.col1PreItems = [];
    this.col1PostItems = [];
    col1AllItems.filter((item) => !col1BiggerArr.includes(item)).forEach((item) => {
      const pos = col1Bigger ? col1Bigger.compareDocumentPosition(item) : 0;
      if (pos & Node.DOCUMENT_POSITION_FOLLOWING) {
        this.col1PostItems.push(item);
      } else {
        this.col1PreItems.push(item);
      }
    });

    this.col2Text = document.querySelector('main.top .section3 .col.col2 .text');
    this.col2Groups = this.buildTextGroups(this.col2Text);

    this.initTextMotion(this.col1PreItems);
    gsap.set(this.col1BiggerItems, { scale: 0, opacity: 0 });
    this.initTextMotion(this.col1PostItems);
    this.col2Groups.forEach((group) => {
      if (group.type === 'bigger') {
        gsap.set(group.items, { scale: 0, opacity: 0 });
      } else {
        this.initTextMotion(group.items);
      }
    });

    this.bigCircle = document.querySelector('main.top .section3 .circle');

    this.parallaxImages = [
      document.querySelector('main.top .section3 .col.col1 .img img'),
      document.querySelector('main.top .section3 .col.col2 .img img'),
    ];
  }

  initEvents() {
    super.initEvents();
  }

  initTextMotion(items) {
    gsap.set(items, { y: 18, opacity: 0 });
  }

  playCol1TextMotion() {
    const biggerDelay = 0.3;
    const postDelay = biggerDelay + (this.col1BiggerItems.length - 1) * 0.025 + 0.15;

    // bigger 前のアイテムをまとめて
    gsap.fromTo(this.col1PreItems,
      { y: 18, opacity: 0 },
      { y: 0, opacity: 1, duration: 2.2, ease: 'elastic.out(1, 0.5)' }
    );
    // .bigger 内を少し遅れて時間差で（scale elastic）
    gsap.fromTo(this.col1BiggerItems,
      { scale: 0, opacity: 0 },
      { scale: 1, opacity: 1, duration: 0.5, ease: 'back.out(2.5)', stagger: 0.025, delay: biggerDelay }
    );
    // bigger 後のアイテムを bigger が出揃ってからまとめて
    gsap.fromTo(this.col1PostItems,
      { y: 18, opacity: 0 },
      { y: 0, opacity: 1, duration: 2.2, ease: 'elastic.out(1, 0.5)', delay: postDelay }
    );
  }

  buildTextGroups(textEl) {
    const ps = textEl ? Array.from(textEl.querySelectorAll('p')) : [];
    const groups = [];

    ps.forEach((p, pIndex) => {
      const allItems = Array.from(p.querySelectorAll('.item'));
      let currentGroup = null;
      let firstInP = true;

      allItems.forEach((item) => {
        const type = item.closest('.bigger') ? 'bigger' : 'other';
        if (!currentGroup || currentGroup.type !== type) {
          currentGroup = { type, items: [], newParagraph: firstInP && pIndex > 0 };
          groups.push(currentGroup);
          firstInP = false;
        }
        currentGroup.items.push(item);
      });
    });

    return groups;
  }

  playCol2TextMotion() {
    let delay = 0;

    this.col2Groups.forEach((group, i) => {
      if (i > 0) {
        const prev = this.col2Groups[i - 1];
        const prevLastStart = prev.type === 'bigger' ? (prev.items.length - 1) * 0.025 : 0;
        const gap = group.newParagraph ? 0.65 : 0.15;
        delay += prevLastStart + gap;
      }

      if (group.type === 'bigger') {
        gsap.fromTo(group.items,
          { scale: 0, opacity: 0 },
          { scale: 1, opacity: 1, duration: 0.5, ease: 'back.out(2.5)', stagger: 0.025, delay }
        );
      } else {
        gsap.fromTo(group.items,
          { y: 18, opacity: 0 },
          { y: 0, opacity: 1, duration: 2.2, ease: 'elastic.out(1, 0.5)', delay }
        );
      }
    });
  }

  initBigCircleAnimation() {
    if (!this.bigCircle) return;

    const mag = 30; // rem

    this.bigCircleTween = gsap
      .timeline({
        repeat: -1,
        yoyo: true,
        paused: true,
      })
      .to(this.bigCircle, {
        x: () => `${this.pack.random(-mag, mag)}rem`,
        y: () => `${this.pack.random(-mag, mag)}rem`,
        duration: 7,
        ease: 'sine.inOut',
      })
      .to(this.bigCircle, {
        x: () => `${this.pack.random(-mag, mag)}rem`,
        y: () => `${this.pack.random(-mag, mag)}rem`,
        duration: 8,
        ease: 'sine.inOut',
      })
      .to(this.bigCircle, {
        x: 0,
        y: 0,
        duration: 9,
        ease: 'sine.inOut',
      });
  }

  start() {}

  scrollHandler() {
    const sh = window.innerHeight;

    if (this.col1Text && !this.col1Text.classList.contains('show')) {
      if (this.col1Text.getBoundingClientRect().top <= sh - 100) {
        this.col1Text.classList.add('show');
        this.playCol1TextMotion();
      }
    }

    if (this.col2Text && !this.col2Text.classList.contains('show')) {
      if (this.col2Text.getBoundingClientRect().top <= sh - 100) {
        this.col2Text.classList.add('show');
        this.playCol2TextMotion();
      }
    }

    if (this.parallaxImages && this.parallaxImages.length > 0) {
      this.parallaxImages.forEach((img) => {
        if (!img) return;
        const parent = img.parentElement;
        const rect = parent.getBoundingClientRect();

        // 親要素が画面内（あるいはその付近）にある場合のみ計算
        if (rect.top < sh && rect.bottom > 0) {
          const centerPos = rect.top + rect.height / 2;
          const screenCenter = sh / 2;
          const dist = centerPos - screenCenter;
          // パララックスの強度（値が大きいほど大きく動く）
          gsap.set(img, { y: dist * this.parallaxSpeed });
        }
      });
    }

    if (this.bigCircleTween) {
      const rect = this.section3Dom.getBoundingClientRect();
      const isInView = rect.top < sh && rect.bottom > 0;

      if (isInView) {
        this.bigCircleTween.play();
      } else {
        this.bigCircleTween.pause();
      }
    }
  }

  enterframe() {}

  enterframeThinOut() {}

  executeResize() {
    super.executeResize();
    this.parallaxSpeed = this.sw >= this.pack.BP ? 0.17 : 0.1;
  }
}
